class CartIconBubble extends HTMLElement {
  constructor() {
    super();

    this.cartIcon = this.querySelector('[data-cart-icon-bubble]');
    this.cartNotification = document.getElementById('cart-notification');

    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.cartIcon) {
      this.cartIcon.addEventListener('click', this.toggleCartNotification.bind(this));
    }
  }

  toggleCartNotification(evt) {
    evt.preventDefault();

    if (this.cartNotification.classList.contains('active')) {
      this.closeCartNotification();
    } else {
      this.cartNotification.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
      document.querySelector('[data-cart-notification-bg]').classList.add('active');

      window.dispatchEvent(new CustomEvent('cart:opened'));

      this.cartNotification.addEventListener('transitionend', () => {
        // if there are products in the cart, set the active element to the checkout button. Else set it to the modal close button
        if (this.cartNotification.querySelector('.cart-notification-product-item')) {
          this.cartNotification.querySelector('button[name="checkout"]').focus();
        } else {
          this.cartNotification.querySelector('[data-cart-notification-close]').focus();
        }
      });

      document.body.addEventListener('click', this.onBodyClick);
    }
  }

  closeCartNotification() {
    this.cartNotification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.querySelector('[data-cart-notification-bg]').classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);
    window.dispatchEvent(new CustomEvent('cart:closed'));

    removeTrapFocus(this.activeElement);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.cartNotification && !target.closest('cart-notification') && !target.closest('cart-icon-bubble')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.closeCartNotification();
    }
  }
}

customElements.define('cart-icon-bubble', CartIconBubble);
